import { Row, Col, Typography } from "antd";
import React from "react";
const { Title, Text } = Typography;

export const PolicyConfirm: React.FC = (): React.ReactElement => {
  return (
    <div>
      <Row>
        <Col>
          <div className="text-center mt-[5px]">
            <Typography className="font-bold w-full">{`Data Privacy Consent`}</Typography>
          </div>
          <br></br>
          <div className="rounded-[15px] border-[0.5px] border-grey border-style-groove p-[10px] h-[400px] text-grey overflow-x-auto">
            <Title level={5}>Thailand Privacy Policy</Title>
            <br></br>
            <Text type="secondary">
              {`At O S D Co., Ltd., our mission is to empower businesses by offering optimal digital solutions that lead to improved outcomes and enhanced customer satisfaction. Your trust is essential to us, and to demonstrate our commitment, we are providing you with the following information regarding the data we collect from you and how we utilize it to deliver the best possible experience.This Privacy Policy describes our practices in connection with information that we collect through activities that link to this Privacy Policy including websites (our “Websites”) and any mobile sites, web applications, and other mobile interactive features (collectively, our “Web Apps”), through other services that we may offer in connections with our Websites and Web Apps, such as promotions, rewards programs, through our official social media pages that we control (our “Social Media Pages”), as well as through HTML-formatted email messages that we send to you (collectively, including the Social Media Pages, Apps and Websites, the “Sites”). `}
            </Text>
            <br></br>
            <Text type="secondary" underline>
              {`By providing Personal Information to us, you agree to and explicitly consent to the terms and conditions of this Privacy Policy. `}
            </Text>
            <br></br>
            <Text type="secondary" strong>
              {`Ensuring the utmost privacy is a top priority for us, but what truly matters to us is the sincere dedication we have towards nurturing our relationship with you.`}
            </Text>
            <Title level={5}>PERSONAL INFORMATION</Title>
            <Text type="secondary">{`"Personal Information" generally means any information that identifies you as an individual, whether directly or indirectly, and any other information we associate with it. We collect a few categories of information, from a few different sources:`}</Text>
            <br></br>
            <Text type="secondary">{`1. Profile information and other content you voluntarily provide us, which may include:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	Contact information when you register on our Sites, such as your name, mobile and home phone number, and/or email address. `}</Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	Any information you provide in communications with us, such as via social media, e-mail or our customer call center.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`2. Information that is passively collected when you use the Sites, such as by our web servers and by third party analytics tools we use:`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	Our system logs may record certain information about visitors to our Sites, including the web request, Internet Protocol (“IP”) address, device and mobile ad identifiers, browser information, interaction with the Sites, pages viewed, app usage, and other such information; we may collect similar information from emails you receive from us that can help us track which emails are opened and which links are clicked by recipients.`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	We use certain cookies, pixel tags and other technologies to help us understand how you use the Sites and enable us to personalize your experience.  We may ask advertisers or other third party partners to serve ads or services to your devices, which rely on cookies or similar technologies placed on our Sites.`}
            </Text>
            <Title level={5}>How We May Use Personal Information</Title>
            <br></br>
            <Text type="secondary">
              {`We may use Personal Information as permitted by law, for the following business purposes:`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to respond to your inquiries and fulfill your requests`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to communicate with you about and to services, promotions, campaigns, rewards and accounts`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to inform you about our products&solution, promotions, events or other promotional purposes`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to re-contact you if we have not heard from you in a while`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to send you advertising/promotional material from any of our affiliates, and on behalf of our promotional and strategic partners`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to perform analytics, quality control, market research, and determine the effectiveness of our websites, web applications, promotional campaigns, and develop new products and services`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`We may also use Personal Information as we believe to be necessary or appropriate for certain essential purposes, including:`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to comply with applicable law and legal process`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to respond to requests from public and government authorities, including public and government authorities outside your country of residence`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to facilitate the functionality of our web applications and websites`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to enforce our terms and conditions`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to protect our operations or those of our affiliates`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to protect our rights, privacy, safety or property, security and/or that of our affiliates, you or others`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	to allow us to pursue available remedies or limit the damages that we may sustain`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`If you submit any Personal Information relating to other people in connection with the Sites, you represent that you have the authority to do so and to permit us to use the information in accordance with this Privacy Policy. It is important to note that failure to provide us with your Personal Information under these circumstances may result in us being unable to enter into a contract with you, to perform our contractual obligations, or to comply with legal obligations, or found to be in violation or non-compliance with any applicable law or regulation.`}
            </Text>
            <Title level={5}>How Personal Information May Be Disclosed</Title>
            <br></br>
            <Text type="secondary">{`1. To the extent permitted by law, all your Personal Information may be disclosed with the following categories of third parties:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	to our affiliates for the purposes described in this Privacy Policy`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	to our third-party service providers who provide services such as website hosting, data analysis, payment processing, order fulfillment, infrastructure provision, IT services, customer service, email delivery services and other services, to enable them to provide services`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	to a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer or other disposition of all or any portion of our business, assets or stock (including in connection with any bankruptcy or similar proceedings)`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	in connection with the essential purposes described above (e.g., to comply with legal obligations)`}</Text>
            <br></br>
            <Text type="secondary">{`2. To the extent permitted by law, your name and contact information (and other information you make public) may be disclosed with the following categories of third parties:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	to third-party strategic partners with whom we may enter into a special relationship for promotional activities, where permitted by law`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	to third parties in connection with certain promotions or marketing activities you may participate in. To the extent that a promotion’s rules concerning the treatment of your Personal Information are stricter than this Privacy Policy, the promotion’s rules apply.`}</Text>
            <br></br>
            <Text type="secondary">{`3. To the extent permitted by law, information that is passively collected when you use the Sites may be disclosed with the following categories of third parties:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	our online and email advertisers or other third-party vendors we use who may provide cookies or other similar technologies for use on our Sites or other websites to manage and improve our online and email advertising campaigns.`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[40px]"
            >{`For example, a vendor (e.g., Google, Facebook) may provide us with certain digital advertising pixels or other tools to recognize their cookies during your visit to the Sites and to learn which of our online advertisements may have brought you to our Sites, or to serve you with advertisements after you leave the Sites.  These third-party vendors may also use other digital advertising tools, as well as your Personal Information, to recognize you across the devices and online services you use.  `}</Text>
            <Title level={5}>
              Publishing and Sending your Personal Information
            </Title>
            <br></br>
            <Text type="secondary">{`We will not disclose your personal information to third parties unless in the following circumstances:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• When we receive a request or consent from you, and/or`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• When the service provider is legally obligated to disclose your information.`}</Text>
            <Title level={5}>Transferring your Personal Information</Title>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`In case the destination country has in sufficient standards, we will provide measures for sending or transferring personal data in accordance with the law. And will take measures to protect personal data that it deems necessary and appropriate in accordance with confidentiality standards, such as having confidentiality agreements with data recipients in the destination country. `}</Text>
            <Title level={5}>Collect your Personal Information </Title>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`We will collect your personal information confidentially, maintaining the accuracy and completeness of the data and in a condition that is always ready for use. The technology used to store and maintain your personal information will be appropriate and up-to-date technology according to the technology available in the market. We have implemented policies, regulations, and criteria to safeguard personal data, including security standards for information technology systems and measures to prevent data recipients from using or disclosing information for purposes other than its intended use or without proper authorization.`}
            </Text>
            <Title level={5}>
              YOUR RIGHTS UNDER PERSONAL DATA PROTECTION ACT, B.E. 2562 (“PDPA”)
            </Title>
            <br></br>
            <Text type="secondary">
              {`You have the following rights in relation to the Personal Information that we hold about you:`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`1. Right to access and obtain copyYou have the right to access and obtain copy of your  Personal Information held by us, unless we are entitled to reject your request under the laws or court orders, or if such request will adversely affect the rights and freedoms of other individuals.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`2. Right to rectification You have the right to rectify your inaccurate Personal Information and to update your incomplete  Personal Information to make it accurate, up-to-date, complete and not misleading.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`3. Right to erasure You have the right to request us to delete, destroy or anonymize your  Personal Information, unless there are certain circumstances where we have the legal grounds to reject your request.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`4. Right to restriction of processing You have the right to request us to restrict the use of your  Personal Information under certain circumstances, e.g. when there is pending an examination process in accordance with your request to rectify your  Personal Information or to object to the collection, use or disclosure of your  Personal Information, or you request to restrict the use of  Personal Information instead of the deletion or destruction of  Personal Information which is no longer necessary.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`5. Right to object You have the right to object to the collection, use or disclosure of your  Personal Information in case we proceed with legitimate interests basis or for the purpose of direct marketing, or for the purpose of scientific, historical or statistic research, unless we have legitimate grounds to reject your request. For instance, we have compelling legitimate grounds to collect, use or disclose your  Personal Information, or the collection, use or disclosure of your  Personal Information is carried out for the establishment, compliance, or exercise legal claims, or for the reason of our public interests.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`6. Right to data portability You have the right to receive your  Personal Information in case we can arrange such  Personal Information to be in the format which is readable or commonly used by ways of automatic tools or equipment and can be used or disclosed by automated means. Also, you have the right to request us to send or transfer your  Personal Information to a third party, or to receive your  Personal Information which we sent or transferred to the third party, unless it is impossible to do so due to technical circumstances, or because we exercise its legitimate right to reject your request.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`7. Right to withdraw consent You have the right to withdraw your consent that has been given to us at any time pursuant to the methods and means prescribed by us, unless the nature of consent does not allow such withdrawal.`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`8. Right to lodge a complaint You have the right to make a complaint with the Expert Committee appointed by the Personal Data Protection Commission (“PDPC”) or their office if we do not comply with the PDPA. Notwithstanding that, we would encourage you to first contact us of any of your concerns prior to lodging complaint to the Expert Committee.`}
            </Text>
            <Title level={5}>RETENTION PERIOD</Title>
            <br></br>
            <Text type="secondary">
              {`We will retain your Personal Information for the period necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by for legal, auditing, or compliance purposes.`}
            </Text>
            <Title level={5}>CONTACTING US</Title>
            <br></br>
            <Text type="secondary">
              {`You can utilize and manage your rights regarding your personal data through www.osd.co.th or by contacting the Data Protection Officer to manage your rights or file any complaints related to the collection, use, and processing of your personal data at dpo@osd.co.th`}
            </Text>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <Title level={5}>นโยบายคุ้มครองข้อมูลส่วนบุคคล</Title>
            <Text type="secondary" className="pl-[20px]">
              {`ภารกิจเพิ่มประสิทธิภาพให้ธุรกิจ ด้วยดิจิทัล โซลูชั่น ที่ทำให้เกิดประโยชน์สูงสุด เพื่อผลลัพธ์ที่ดีกว่า และก่อให้เกิดความพึงพอใจแก่ทุกคน ซึ่ง บริษัท โอ เอส ดี จำกัด (ต่อไปนี้เรียกว่า “บริษัท”) ไม่สามารถทำได้หากไม่ได้รับไว้วางใจจากคุณ ดังนั้น บริษัทจึงแจ้งรายละเอียดดังต่อไปนี้แก่คุณเพื่อแสดงให้เห็นอย่างชัดเจนถึงรายละเอียดเกี่ยวกับ ข้อมูลที่บริษัทได้มีการเก็บรวบรวม และวิธีการใช้ข้อมูลนั้น ทั้งนี้เพื่อมอบประสบการณ์ที่ดีที่สุดและสิทธิประโยชน์ที่ดีที่สุดที่บริษัทสามารถทำได้`}
            </Text>
            <Text type="secondary" className="pl-[20px]">
              {`นโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้อธิบายแนวทางปฏิบัติของบริษัทเกี่ยวกับข้อมูลที่บริษัทเก็บรวบรวมผ่านกิจกรรมที่ถูกเชื่อมต่อมายังนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ รวมถึงเว็บไซต์ ("เว็บไซต์" ของบริษัท) และเว็บไซต์สำหรับอุปกรณ์พกพา เว็บแอปพลิเคชัน และฟีเจอร์การโต้ตอบบนอุปกรณ์พกพาอื่น ๆ (เรียกรวมกันว่า "เว็บแอป" ของบริษัท) ผ่านบริการอื่น ๆ ที่บริษัทอาจนำเสนอในการเข้าถึงเว็บไซต์และเว็บแอปของบริษัท เช่น การส่งเสริมการขาย โปรโมชั่น การแจกรางวัล ผ่านเพจโซเชียลมีเดียอย่างเป็นทางการของบริษัทที่บริษัทเป็นผู้ควบคุม ("เพจโซเชียลมีเดีย") รวมทั้งกรณีผ่านข้อความอีเมลในรูปแบบ HTML ที่บริษัทส่งถึงคุณ (เพจโซเชียลมีเดีย เว็บแอป และเว็บไซต์ รวมเรียกว่า "ไซต์")`}
            </Text>
            <Text underline>
              {`การให้ข้อมูลส่วนบุคคลแก่บริษัทหมายความว่าคุณยอมรับและยินยอมอย่างชัดเจนต่อข้อกำหนดและเงื่อนไขของนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`บริษัทให้ความสำคัญกับความเป็นส่วนบุคคลอย่างจริงจัง และที่สำคัญกว่านั้น บริษัทให้ความสำคัญกับความสัมพันธ์ของบริษัทกับคุณอย่างจริงจังเช่นกัน`}
            </Text>
            <Title level={5}>ข้อมูลส่วนบุคคล</Title>
            <Text type="secondary">{`"ข้อมูลส่วนบุคคล" โดยทั่วไปหมายถึง ข้อมูลใด ๆ ที่เกี่ยวข้องหรือที่สามารถระบุตัวตนของท่านได้ไม่ว่าจะโดยตรงหรือโดยอ้อม และข้อมูลอื่นใดที่เกี่ยวข้อง บริษัทจะมีการเก็บรวบรวมประเภทของข้อมูลต่าง ๆ จากแหล่งที่มาต่าง ๆ`}</Text>
            <br></br>
            <Text type="secondary">{`1. ข้อมูลประวัติบุคคล และเนื้อหาอื่น ๆ ที่คุณสมัครใจให้กับบริษัท ซึ่งอาจรวมถึง`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	ข้อมูลติดต่อเมื่อคุณลงทะเบียนบนไซต์ของบริษัท เช่น ชื่อ หมายเลขโทรศัพท์มือถือและโทรศัพท์บ้าน และ/หรือที่อยู่อีเมล`}</Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	ข้อมูลใด ๆ ที่คุณให้ในการสื่อสารกับบริษัท เช่น ผ่านโซเชียลมีเดีย อีเมล หรือศูนย์บริการลูกค้าของบริษัท`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`2. ข้อมูลที่เก็บรวบรวมเมื่อคุณใช้ไซต์ เช่น การเก็บข้อมูลโดยเว็บเซิร์ฟเวอร์ของบริษัท และเครื่องมือวิเคราะห์ของบุคคลภายนอกที่บริษัทใช้:`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	บันทึกการใช้งานระบบของบริษัท ที่อาจมีอาจบันทึกข้อมูลบางอย่างเกี่ยวกับผู้เยี่ยมชมไซต์ของบริษัท รวมถึงคำขอจากเว็บไซต์ ที่อยู่อินเทอร์เน็ตโปรโตคอล (“ไอพี”) เครื่องมือระบุการโฆษณาบนอุปกรณ์และมือถือ ข้อมูลบราว์เซอร์ การโต้ตอบทางไซต์ หน้าเว็บที่มีการเข้าถึง การใช้เว็บแอป และข้อมูลอื่น ๆ โดยบริษัทอาจมีการเก็บรวบรวมข้อมูลที่คล้ายกันจากอีเมลที่คุณได้รับจากบริษัท ซึ่งสามารถช่วยให้บริษัทติดตามได้ว่าอีเมลใดที่ถูกเปิดอ่านแล้ว และลิงก์ใดที่ถูกคลิกหรือเข้าถึงแล้ว`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	บริษัทมีการใช้คุกกี้ และเทคโนโลยีอื่น ๆ เพื่อช่วยให้บริษัทเข้าใจว่าคุณใช้ไซต์อย่างไร และทำให้บริษัทสามารถปรับเปลี่ยนประสบการณ์การใช้งานให้เข้ากับคุณได้ บริษัทอาจขออนุญาตให้ผู้โฆษณาหรือพันธมิตรบุคคลภายนอก ส่งโฆษณาหรือบริการไปยังอุปกรณ์ของคุณ ซึ่งจะมีการอาศัยการใช้คุกกี้หรือเทคโนโลยีที่คล้ายคลึงกันที่วางอยู่บนไซต์ของบริษัท`}
            </Text>
            <Title level={5}>วิธีการที่บริษัทอาจใช้ข้อมูลส่วนบุคคล</Title>
            <br></br>
            <Text type="secondary">
              {`บริษัทอาจมีการใช้ข้อมูลส่วนบุคคลตามที่กฎหมายอนุญาต เพื่อวัตถุประสงค์ทางธุรกิจดังต่อไปนี้:`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อตอบคำถามของคุณและตอบสนองความต้องการของคุณ`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อสื่อสารกับคุณเกี่ยวกับ การส่งเสริมการขาย โปรโมชั่น และการชิงรางวัล `}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อแจ้งให้คุณทราบเกี่ยวกับองค์กร โปรดักส์และโซลูชั่น โปรโมชั่น กิจกรรม หรือวัตถุประสงค์ในการส่งเสริมการขาย อื่น ๆ ของบริษัท `}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อการติดต่อกลับหาคุณ หากบริษัทไม่ได้รับการติดต่อจากคุณเป็นระยะเวลาหนึ่ง `}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อการส่งสื่อโฆษณา/ส่งเสริมการขายจากบริษัทในเครือของบริษัท และในนามของพันธมิตรที่เกี่ยวข้องกับการส่งเสริมการขายและกลยุทธ์ของบริษัท`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อการดำเนินการวิเคราะห์ การควบคุมคุณภาพ วิจัยด้านการตลาด และกำหนดประสิทธิภาพของเว็บไซต์ แคมเปญส่งเสริมการขาย และพัฒนาผลิตภัณฑ์และบริการใหม่`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`บริษัทอาจใช้ข้อมูลส่วนบุคคลตามที่บริษัทเชื่อว่าจำเป็นหรือเหมาะสมสำหรับวัตถุประสงค์ที่สำคัญ ดังต่อไปนี้`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อให้เป็นไปตามกฎหมายและกระบวนการทางกฎหมายที่มีผลบังคับใช้`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อตอบสนองต่อคำขอจากหน่วยงานผู้มีอำนาจของรัฐ หรือรัฐบาล ซึ่งอาจรวมถึงหน่วยงานผู้มีอำนาจของรัฐ หรือรัฐบาลนอกประเทศที่คุณอาศัยอยู่`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่ออำนวยความสะดวกในการใช้งานเว็บแอปพลิเคชันและเว็บไซต์ของบริษัท`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อบังคับใช้ตามข้อกำหนดและเงื่อนไขของบริษัท`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อปกป้องการดำเนินงานของบริษัทหรือบริษัทในเครือ`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`• เพื่อปกป้องสิทธิ ความเป็นส่วนบุคคล ความปลอดภัยหรือทรัพย์สิน และ/หรือการรักษาความปลอดภัย ของบริษัท บริษัทในเครือ คุณ และ/หรือบุคคลอื่น`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`•	เพื่อให้บริษัทสามารถดำเนินการแก้ไขตามแนวทางที่สามารถทำได้ หรือจำกัดความเสียหายที่บริษัทอาจได้รับ หากคุณมีการส่งข้อมูลส่วนบุคคลของบุคคลอื่นโดยการเชื่อมต่อกับไซต์ คุณรับรองว่าคุณมีอำนาจในการดำเนินการดังกล่าว และอนุญาตให้บริษัทใช้ข้อมูลได้ตามนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้`}
            </Text>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`สิ่งสำคัญที่คุณจะต้องทราบคือ หากคุณไม่ให้ข้อมูลส่วนบุคคลแก่บริษัทภายใต้สถานการณ์เหล่านี้ อาจส่งผลกระทบทำให้บริษัทไม่สามารถทำสัญญากับคุณ หรือไม่สามารถปฏิบัติตามภาระผูกพันตามสัญญาของบริษัท หรือไม่สามารถปฏิบัติตามภาระหน้าที่ทางกฎหมายได้ หรืออาจทำให้เป็นการละเมิด หรือไม่ปฏิบัติตามกฎหมายหรือข้อบังคับที่เกี่ยวข้อง`}
            </Text>
            <Title level={5}>วิธีการที่อาจมีการเปิดเผยข้อมูลส่วนบุคคล</Title>
            <br></br>
            <Text type="secondary">{`1. ภายใต้ขอบเขตที่กฎหมายอนุญาต ข้อมูลส่วนบุคคลทั้งหมดของคุณอาจถูกเปิดเผยให้กับบุคคลภายนอกประเภทต่างๆ ดังต่อไปนี้:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• เปิดเผยให้แก่ในเครือตามวัตถุประสงค์ที่ได้อธิบายไว้ในนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้`}</Text>{" "}
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• เปิดเผยให้แก่ผู้ให้บริการบุคคลภายนอกของบริษัทที่ให้บริการต่าง ๆ เช่น การโฮสต์เว็บไซต์ การวิเคราะห์ข้อมูล การปฏิบัติตามคำสั่ง การจัดหาโครงสร้างพื้นฐาน บริการด้านสารสนเทศ การบริการลูกค้า บริการจัดส่งอีเมล และบริการอื่น ๆ เพื่อให้บุคคลดังกล่าวสามารถให้บริการได้`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• เปิดเผยให้แก่บุคคลภายนอกในกรณีที่มีการปรับโครงสร้างองค์กร การควบรวมกิจการ การขาย การร่วมทุน การมอบหมาย การโอน หรือการจำหน่ายอื่น ๆ ของธุรกิจ ทรัพย์สิน หรือหุ้นทั้งหมดหรือบางส่วนของบริษัท (ซึ่งรวมถึงการล้มละลายหรือการดำเนินการที่คล้ายคลึงกัน)`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• เปิดเผยให้แก่บุคคลอื่นใดที่เกี่ยวข้องกับวัตถุประสงค์ที่จำเป็นตามที่อธิบายไว้ข้างต้น (เช่น เพื่อปฏิบัติตามภาระผูกพันทางกฎหมาย)`}</Text>
            <br></br>
            <Text type="secondary">{`2. ภายใต้ขอบเขตที่กฎหมายอนุญาต ชื่อและข้อมูลติดต่อของคุณ (และข้อมูลอื่น ๆ ที่คุณเปิดเผยต่อสาธารณะ) อาจถูกเปิดเผยต่อบุคคลภายนอกประเภทต่างๆ ดังต่อไปนี้:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• พันธมิตรบุคคลภายนอกที่เกี่ยวข้องกับการวางกลยุทธ์ ซึ่งบริษัทอาจมีความสัมพันธ์พิเศษเพื่อการจัดกิจกรรมส่งเสริมการขายตามที่กฎหมายอนุญาต`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• บุคคลภายนอกที่เกี่ยวข้องกับโปรโมชั่นหรือกิจกรรมทางการตลาดที่คุณอาจเข้าร่วม หากในกรณีที่กฎของโปรโมชั่นซึ่งเกี่ยวข้องกับการใช้ข้อมูลส่วนบุคคลนั้น เข้มงวดกว่านโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ ให้ใช้กฎของโปรโมชั่นนั้นบังคับแทนนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้`}</Text>
            <br></br>
            <Text type="secondary">{`3. ภายใต้ขอบเขตที่กฎหมายอนุญาต ข้อมูลที่ได้มีการเก็บรวบรวมไว้เมื่อคุณใช้ไซต์อาจถูกเปิดเผยกับบุคคลภายนอกประเภทต่าง ๆ ต่อไปนี้:`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• ผู้โฆษณาทางออนไลน์และทางอีเมลของบริษัท หรือผู้ให้บริการบุคคลภายนอกอื่น ๆ ที่บริษัทใช้ ซึ่งอาจเปิดเผย คุกกี้ หรือเทคโนโลยีอื่นที่คล้ายคลึงกันสำหรับการใช้บนไซต์ของบริษัทหรือเว็บไซต์อื่น ๆ เพื่อการจัดการและปรับปรุงแคมเปญโฆษณาออนไลน์และอีเมลของบริษัท`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[40px]"
            >{`• ตัวอย่างเช่น ผู้ให้บริการ (เช่น Google, Facebook) อาจให้พิกเซลโฆษณาดิจิทัลบางอย่างแก่บริษัท หรือให้เครื่องมืออื่น ๆ เพื่อการจดจำคุกกี้ของระหว่างที่คุณเยี่ยมชมไซต์ และเพื่อเรียนรู้ว่าโฆษณาออนไลน์ใดของบริษัทสามารถนำคุณมาเยี่ยมไซต์ของบริษัท หรือ เพื่อส่งโฆษณาให้คุณหลังจากที่คุณออกจากไซต์ ผู้ให้บริการบุคคลภายนอกเหล่านี้อาจใช้เครื่องมือโฆษณาดิจิทัลอื่น ๆ รวมทั้งข้อมูลส่วนบุคคลของคุณ เพื่อจดจำคุณผ่านอุปกรณ์และบริการออนไลน์ที่คุณใช้`}</Text>
            <Title level={5}>การเปิดเผยและส่งต่อข้อมูลส่วนบุคคล</Title>
            <br></br>
            <Text type="secondary">{`บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านไปยังบุคคลที่สาม เว้นแต่กรณีดังต่อไปนี้ `}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`• เมื่อได้รับคำร้องขอหรือความยินยอมจากท่าน และ/หรือ`}</Text>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`•	เมื่อผู้ให้บริการมีหน้าที่ตามกฎหมายที่จะต้องเปิดเผยข้อมูลของท่าน`}</Text>
            <Title level={5}>การโอนข้อมูลส่วนบุคคลของคุณ</Title>
            <br></br>
            <Text
              type="secondary"
              className="pl-[20px]"
            >{`กรณีที่ประเทศปลายทางมีมาตรฐานไม่เพียงพอ บริษัทจะจัดให้มีมาตรการการส่งหรือโอนข้อมูลส่วนบุคคลให้เป็นไปตามที่กฎหมายกำหนด และจะดำเนินการให้มีมาตรการคุ้มครองข้อมูลส่วนบุคคลที่เห็นว่าจำเป็นและเหมาะสมสอดคล้องกับมาตรฐานการรักษาความลับ เช่น มีข้อตกลงรักษาความลับกับผู้รับข้อมูลในประเทศปลายทาง`}</Text>
            <Title level={5}>จัดเก็บข้อมูลส่วนบุคคล </Title>
            <br></br>
            <Text type="secondary" className="pl-[20px]">
              {`บริษัทจะดำเนินการจัดเก็บข้อมูลส่วนบุคคลของท่านอย่างเป็นความลับ (confidentiality) คงไว้ซึ่งความถูกต้องครบถ้วนของข้อมูล (integrity) และอยู่ในสภาพที่พร้อมใช้งานตลอดเวลา (availability) ทั้งนี้เทคโนโลยีที่ใช้ในการจัดเก็บ และดูแลรักษาข้อมูลส่วนบุคคลของท่านจะเป็นเทคโนโลยีที่เหมาะสมและทันสมัยตามเทคโนโลยีที่มีอยู่ในท้องตลาด โดยบริษัทได้กำหนดนโยบาย ระเบียบ และหลักเกณฑ์ในการคุ้มครองข้อมูลส่วนบุคคล เช่น มาตรฐานความปลอดภัยของระบบเทคโนโลยีสารสนเทศ และมาตรการเพื่อป้องกันไม่ให้ผู้รับข้อมูลไปจากบริษัทใช้หรือเปิดเผยข้อมูลนอกเหนือจากวัตถุประสงค์ หรือโดยไม่มีอำนาจหรือโดยมิชอบ หากคุณมีเหตุผลที่เชื่อได้ว่าการติดต่อสื่อสารระหว่างคุณกับบริษัทนั้นไม่ปลอดภัย (เช่น หากคุณรู้สึกว่าความปลอดภัยของบัญชีใด ๆ ของคุณที่อาจมีกับบริษัทถูกละเมิด) โปรดแจ้งให้บริษัททราบในทันทีตามหัวข้อ "ติดต่อบริษัท" ด้านล่าง `}
            </Text>
            <Title level={5}>
              สิทธิของคุณภายใต้ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
              (“PDPA”)
            </Title>
            <br></br>
            <Text type="secondary">
              {`คุณมีสิทธิในข้อมูลส่วนบุคคลที่บริษัทได้มีการเก็บรวบรวม ดังนี้`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`1. สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (Right to access and obtain copy)คุณมีสิทธิเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคลของคุณที่อยู่ภายใต้ความรับผิดชอบของบริษัท เว้นแต่บริษัทจะมีสิทธิปฏิเสธคำขอของคุณภายใต้กฎหมายหรือคำสั่งศาล หรือหากคำขอดังกล่าวจะส่งผลกระทบอันร้ายแรงต่อสิทธิและเสรีภาพของบุคคลอื่น`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`2. สิทธิในการแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง (Right to rectification) คุณมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของคุณที่ไม่ถูกต้องให้ถูกต้อง และปรับปรุงข้อมูลของคุณที่ไม่สมบูรณ์ให้ถูกต้อง เป็นปัจจุบัน และครบถ้วนสมบูรณ์ เพื่อไม่ให้เกิดความเข้าใจผิด`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`3. สิทธิในการลบข้อมูลส่วนบุคคล (Right to erasure) คุณมีสิทธิขอให้บริษัทลบ ทำลายข้อมูล หรือทำให้ข้อมูลของคุณเป็นข้อมูลที่ไม่สามารถระบุตัวตนได้ เว้นแต่กรณีที่บริษัทมีเหตุทางกฎหมายที่จะปฏิเสธคำขอของคุณ`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`4. สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (Right to restriction of processing) คุณมีสิทธิที่จะขอให้บริษัทระงับการใช้ข้อมูลส่วนบุคคลของคุณในกรณีต่าง ๆ เช่น เมื่อบริษัทอยู่ในระหว่างดำเนินกระบวนการตรวจสอบตามคำร้องขอของท่านให้แก้ไขข้อมูลส่วนบุคคลของคุณ หรือคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ หรือในกรณีที่คุณขอให้บริษัทมีการระงับการใช้ข้อมูลแทนการลบหรือทำลายข้อมูลส่วนบุคคลที่ไม่จำเป็นต้องใช้อีกต่อไป`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`5. สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (Right to object)คุณมีสิทธิที่จะคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณในกรณีที่บริษัทดำเนินการภายใต้ฐานผลประโยชน์ที่ชอบด้วยกฎหมาย หรือเพื่อทำการตลาดแบบตรง การวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์ หรือสถิติ เว้นแต่ บริษัทจะมีเหตุอันชอบธรรมในการปฏิเสธคำขอของคุณ ตัวอย่าง เช่น บริษัทมีเหตุผลตามกฎหมายในการเก็บรวบรวม ประมวล หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ หรือการเก็บรวบรวม ประมวล หรือเปิดเผยข้อมูลส่วนบุคคลของท่านนั้นเป็นไปเพื่อก่อตั้ง ปฏิบัติตาม ใช้ หรือยกขึ้นต่อสู้สิทธิเรียกร้องทางกฎหมาย หรือเพื่อประโยชน์สาธารณะ`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`6. สิทธิในการขอให้โอนย้ายข้อมูลส่วนบุคคล (Right to data portability)คุณมีสิทธิที่จะได้รับข้อมูลส่วนบุคคลของคุณในกรณีที่บริษัทสามารถจัดเตรียมข้อมูลส่วนบุคคลดังกล่าวให้อยู่ในรูปแบบที่สามารถอ่านได้หรือใช้กันได้ทั่วไปโดยใช้เครื่องมือหรืออุปกรณ์อัตโนมัติ และสามารถใช้หรือเปิดเผยได้โดยวิธีอัตโนมัติ นอกจากนี้ คุณยังมีสิทธิขอให้บริษัทส่งหรือโอนข้อมูลส่วนบุคคลของคุณไปยังบุคคลภายนอก หรือขอรับข้อมูลส่วนบุคคลของคุณซึ่งบริษัทได้มีการจัดส่งหรือโอนไปยังบุคคลภายนอก เว้นแต่กรณีบริษัทไม่สามารถดำเนินการตามคำขอของคุณได้ด้วยเหตุทางเทคนิค หรือเนื่องจากบริษัทได้ใช้สิทธิโดยชอบด้วยกฎหมายในการปฏิเสธคำขอ`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`7. สิทธิในการเพิกถอนความยินยอม (Right to withdraw consent)คุณมีสิทธิที่จะถอนความยินยอมของท่านที่ให้ไว้กับบริษัทได้ไม่ว่าจะในเวลาใดก็ตาม ตามวิธีการและขั้นตอนการขอถอนคำยินยอมที่บริษัทกำหนด เว้นแต่ด้วยลักษณะประเภทของความยินยอมนั้นทำให้ไม่สามารถถอนความยินยอมได้`}
            </Text>
            <br></br>
            <Text type="secondary">
              {`8. สิทธิในการยื่นเรื่องร้องเรียน (Right to lodge a complaint)คุณมีสิทธิร้องเรียนต่อคณะกรรมการผู้เชี่ยวชาญซึ่งได้รับการแต่งตั้งโดยคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล(“PDPC”) หรือสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล หากบริษัทไม่ปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล อย่างไรก็ตามบริษัทขอแนะนำให้คุณติดต่อบริษัทหากมีข้อกังวลใด ๆ ก่อนที่จะยื่นเรื่องร้องเรียนต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล`}
            </Text>
            <Title level={5}>ระยะเวลาการจัดเก็บข้อมูล</Title>
            <br></br>
            <Text type="secondary">
              {`บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลของคุณตามระยะเวลาที่จำเป็นเพื่อให้เป็นไปตามวัตถุประสงค์ที่ระบุไว้ในนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ เว้นแต่จะมีการกำหนดหรืออนุญาตให้มีระยะเวลาเก็บรักษานานขึ้นเพื่อวัตถุประสงค์ทางกฎหมาย การตรวจสอบบัญชี หรือการกำกับดูแล`}
            </Text>
            <Title level={5}>ติดต่อบริษัท</Title>
            <br></br>
            <Text type="secondary">
              {`ท่านสามารถใช้และบริหารจัดการสิทธิเกี่ยวกับข้อมูลส่วนบุคคลของท่าน ผ่านทาง www.osd.co.th หรือติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล เพื่อใช้และบริหารจัดการสิทธิเกี่ยวกับข้อมูลส่วนบุคคลของท่านหรือร้องเรียนปัญหาใด ๆ เกี่ยวกับการเก็บรวบรวม ใช้ และประมวลผลข้อมูลส่วนบุคคลของของท่านที่ dpo@osd.co.th `}
            </Text>
          </div>
          <div className="flex justify-center items-center mt-[10px]">
            <Typography className="text-grey mt-[10px] text-[90%] text-center">{`I have read and understood the request for consent and the conditions of such consent.`}</Typography>
          </div>
          {/* </Card> */}
        </Col>
      </Row>
    </div>
  );
};
